/**
 * ============================================================================
 * GENERATED FILE - Created via: pnpm run generate:wetags
 * ============================================================================
 *
 * This file was generated by the wetag library generator.
 *
 * To add new entity types or update configuration, run:
 *   pnpm run generate:wetags
 *
 * You can safely modify this file if needed, but using the generator
 * ensures consistency across all wetag libraries in the codebase.
 *
 * To add type-safe tag names, update the tags.ts file in this directory.
 * ============================================================================
 */

import { createNamespacedWetagHooksForOrg, createNamespacedWetagHooksForUser } from '@frontend/wetags';
import type { TaskCenterTags } from './tags';

const TASK_CENTER_NAMESPACE = 'task-center';

export const TaskCenterOrg = createNamespacedWetagHooksForOrg<TaskCenterTags>(TASK_CENTER_NAMESPACE);
export const TaskCenterUser = createNamespacedWetagHooksForUser<TaskCenterTags>(TASK_CENTER_NAMESPACE);
/* 
This hook is a wrapper around the TaskCenterOrg.useWetagQueries hook, which is generated by the wetag library generator.
It allows you to use the TaskCenterOrg.useWetagQueries hook with the correct namespace and type parameters for the
task-center wetag library. It supports multiple location, default values and strategy parameters, and returns the same
result as the original hook.
*/
export const TaskCenterLocation = (...args: Parameters<typeof TaskCenterOrg.useWetagQueries>) =>
  TaskCenterOrg.useWetagQueries(...args);
